import React from 'react';
import { Button, Icon, Container } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const Homepage = ({ mobile }) => (
  <Container text>
    <Button
      primary
      size="huge"
      style={{
        direction: 'rtl',
        textAlign: 'center',
        margin: 'auto',
        display: 'table',
      }}
      as={Link}
      to="/app"
    >
      بزن بریم!
      <Icon name="left arrow" />
    </Button>
  </Container>
);

export default Homepage;
